import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Modal, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaSignInAlt } from "react-icons/fa";
import { auth } from "../firebase";
import "./menu.css";
import { FaUserCircle } from "react-icons/fa";
import loginLogo from "../assets/login_ttd_logo_govinda.svg"
import { FaHome } from "react-icons/fa";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase"; // adjust path if needed

const Menu = ({ user }) => {
  const [openMenu, setOpenMenu] = useState(null);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false); // ✅ Track admin status
  const [userRole, setUserRole] = useState(null);

  // ✅ Fetch user role on mount
  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        const userRef = doc(db, "users", user.uid); // your users collection
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userData = userSnap.data();
          setIsAdmin(userData.role === "admin");
        }
      }
    };
    fetchUserRole();
  }, [user]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const userDocRef = doc(db, "admin", currentUser.uid); // your structure
        const userDocSnap = await getDoc(userDocRef);
        if (userDocSnap.exists()) {
          setUserRole(userDocSnap.data().role);
        }
      }
    });

    return () => unsubscribe();
  }, []);


  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const handleLogout = async () => {
    await auth.signOut();
    navigate("/");
  };

  const dashboard = () => {
    navigate("/dashboard");
  };

  const handleSrivariSevaClick = () => {
    if (user) {
      navigate("/seva-dashboard");
    } else {
      setShowLoginPrompt(true);
    }
  };

  return (
    <>
      <Navbar expand="lg" sticky="top" style={{ backgroundColor: "#663399" }}>
        {/* <Navbar.Brand as={Link} to="/" className="text-white">
          MyApp
        </Navbar.Brand> */}
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className=" ms-3">
            <Nav.Link as={Link} to="/" className="text-white">
              <FaHome size={20} title="Home" />

            </Nav.Link>

            {isAdmin && (

              <NavDropdown
                title={<span className="text-white">Services</span>}
                id="services-dropdown"
                show={openMenu === "services"}
                onClick={() => toggleMenu("services")}
              >
                <NavDropdown.Item as={Link} to="/uploadFile">
                  Upload Excel File
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/memberdata">
                  Generate Member Data
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/new">
                  Add Sevak
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/newsevak">
                  Add Sevak New
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/grouplist">
                  Group List
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/groupdatagenerate">
                  Code Generator
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/groupdatageneratenew">
                  Code Generator New
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/transfer-member">
                  Transfer Members
                </NavDropdown.Item>
                <NavDropdown.Item>CSR</NavDropdown.Item>
              </NavDropdown>
            )}

            {/* <Nav.Link as={Link} to="/" className="text-white">
              Industries
            </Nav.Link> */}
            <Nav.Link onClick={handleSrivariSevaClick} className="text-white">
              Srivari Seva
            </Nav.Link>

            {/* <NavDropdown
              title={<span className="text-white">About</span>}
              id="company-dropdown"
              show={openMenu === "company"}
              onClick={() => toggleMenu("company")}
            > */}
            {/* <NavDropdown.Item as={Link} to="/">
                About
              </NavDropdown.Item> */}
            {/* <NavDropdown.Item>Case Study</NavDropdown.Item>
              <NavDropdown.Item>Resources</NavDropdown.Item>
              <NavDropdown.Item>Gallery</NavDropdown.Item> */}
            {/* </NavDropdown> */}
            <Nav.Link as={Link} to="https://news.tirumala.org/" target="_blank" className="text-white">
              News
            </Nav.Link>
            <Nav.Link as={Link} to="https://ebooks.tirumala.org/" target="_blank" className="text-white">
              eBooks
            </Nav.Link>

            <Nav.Link as={Link} to="http://www.svbcttd.com/" target="_blank" className="text-white">
              SVBC
            </Nav.Link>
            <Nav.Link as={Link} to="https://ttdevasthanams.ap.gov.in/temples" target="_blank" className="text-white">
              Temples
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className="text-white">
              About Us
            </Nav.Link>

            <Nav.Link as={Link} to="/contact" className="text-white">
              Contact Us
            </Nav.Link>
            {/* <Nav.Link as={Link} to="/" className="text-white">
              Career
            </Nav.Link> */}
          </Nav>

          <Nav className="ms-auto">
            {user ? (
              <NavDropdown
                title={
                  <FaUserCircle
                    style={{ color: "white", fontSize: "1.5rem" }}
                  />
                }
                id="user-dropdown"
                align="end"
              >
                <NavDropdown.Item onClick={dashboard}>
                  Dashboard
                </NavDropdown.Item>
                <NavDropdown.Item onClick={handleLogout}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link
                as={Link}
                to="/login"
                className="btn btn-primary text-white px-3 rounded d-flex align-items-center"
              >
                <FaSignInAlt className="me-2" />
                Login
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* Login Prompt Modal */}
      {/* <Modal
        show={showLoginPrompt}
        onHide={() => setShowLoginPrompt(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Login Required</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please log in to access Srivari Seva.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLoginPrompt(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => navigate("/login")}>
            Login
          </Button>
        </Modal.Footer>
      </Modal> */}
      {/* 
      <Modal
  show={showLoginPrompt}
  onHide={() => setShowLoginPrompt(false)}
  centered
  dialogClassName="rounded-modal h-50"
>
  <Modal.Header closeButton>
    <Modal.Title className="w-100 text-center">
      <img
        src={loginLogo}
        alt="TTD Logo"
        style={{ height: "60px", marginBottom: "10px" }}
      />
      <div>Login Required</div>
    </Modal.Title>
  </Modal.Header>
  <Modal.Body className="text-center">
    Please log in to access Srivari Seva.
  </Modal.Body>
  <Modal.Footer className="justify-content-center">
    <Button variant="secondary" onClick={() => setShowLoginPrompt(false)}>
      Cancel
    </Button>
    <Button variant="primary" onClick={() => navigate("/login")}>
      Login
    </Button>
  </Modal.Footer>
</Modal> */}

      <Modal
        show={showLoginPrompt}
        onHide={() => setShowLoginPrompt(false)}
        centered
        dialogClassName="rounded-modal tight-modal"
      >
        <Modal.Header closeButton className="border-0 pb-1 pt-2">
          <Modal.Title className="w-100 text-center">
            <img
              src={loginLogo}
              alt="TTD Logo"
              style={{ height: "60px", marginBottom: "10px" }}
            />
            <div>Login Required</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-2">
          Please log in to access Srivari Seva.
        </Modal.Body>
        <Modal.Footer className="justify-content-center pt-1 pb-3 border-0">
          <Button variant="secondary" onClick={() => setShowLoginPrompt(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => navigate("/login")}>
            Login
          </Button>
        </Modal.Footer>
      </Modal>


    </>
  );
};

export default Menu;
